import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import { IFormFieldKey, IForm } from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { additionalDataFactory } from './common/fieldsAdditionalData';
import {
    fieldsLowTableBorders,
    fieldsLowTableMaterial,
    fieldsLowTableOptions,
    lowNestingTableNoLegsTrayShapeDimension,
} from './common/fieldsLowTable';

const lowTableNestingNoLegsForm: IForm = {
    formId       : PublishedFormId.LowTableNestingNoLegs,
    type         : FormTypeId.Table,
    thumbnailURL : '/resized-images/forms/low-table-nesting-no-legs.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.ShapeDimension,
        IFormFieldKey.TrayMaterial,
        IFormFieldKey.SecondMaterial,
        IFormFieldKey.Border,
        IFormFieldKey.AddOns,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        shapeDimension : lowNestingTableNoLegsTrayShapeDimension,
        trayMaterial   : fieldsLowTableMaterial,
        secondMaterial : fieldsLowTableMaterial,
        border         : fieldsLowTableBorders,
        addOns         : fieldsLowTableOptions,
        additionalData : additionalDataFactory({
            budgetMin          : 400,
            budgetMax          : 3000,
            budgetDefaultValue : 1200,
        }),
        contact: fieldsContact,
    },
};

export default lowTableNestingNoLegsForm;
